import "@assets/js/app.js"
import "../../assets/style/styles.scss"
import { mount } from 'svelte';

//CE
import Cta from "./custom-elements/Cta.svelte"
import PageHeader from "./custom-elements/PageHeader.svelte"

export const bizFeesOtherNumber = 130

document.addEventListener("DOMContentLoaded", async () => {
  // --- 共通処理 ---
  // 動的インポートを利用して、必要な関数のみを読み込み実行
  const { BizTextInsert } = await import("./components/TextInsert");
  const { scrollBgScale } = await import("./components/Animation");
  BizTextInsert()
  scrollBgScale()
  
  // bodyのIDに基づいて処理を分岐
  switch (document.body.id) {
    case 'page-business-top': {
      const TOP = document.getElementById("biz-top");
      if (TOP) {
        const { default: TopApp } = await import("./index/App.svelte");
        mount(TopApp, { target: TOP });
      }
      break;
    }
    case 'page-business-open-account-apply': {
      const OpenAccountApply = document.getElementById("biz-openaccount-accept");
      if (OpenAccountApply) {
        const { default: OpenAccountApplyApp } = await import("../../open-account/apply/assets/js/App.svelte");
        mount(OpenAccountApplyApp, { target: OpenAccountApply });
      }
      break;
    }
    case 'page-business-rates-and-fees': {
      const figure = document.getElementById("biz-rates-and-fees-figure");
      if (figure) {
        const { default: RatesAndFeesApp } = await import("../../rates-and-fees/assets/js/App.svelte");
        mount(RatesAndFeesApp, { target: figure });
      }
      break;
    }
    case 'page-business-web-fatca': {
      const webFatca = document.getElementById("biz-webFatca-documents");
      if (webFatca) {
        const { default: WebFatcaApp } = await import("../../web/fatca/assets/js/App.svelte");
        mount(WebFatcaApp, { target: webFatca });
      }
      break;
    }
    case 'page-business-web-guide': {
      const webGuide = document.getElementById("biz-webGuide-more");
      if (webGuide) {
        const { default: WebFatcaApp } = await import("../../web/guide/assets/js/App.svelte");
        mount(WebFatcaApp, { target: webGuide });
      }
      break;
    }
  }
})
